module.exports = __webpack_public_path__ + "img/ic_infinity_v2.fa66a403.svg";